import { useEffect, useState } from 'react';
import classes from './Events.module.css';
import CardEvent from './CardEvent';
import EventModal from './EventModal';
import { getEventStatus } from '../../utils/eventStatus';

export default function Events({ filter = 'upcoming', limit }) {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);

    useEffect(() => {
        fetch('/events.json')
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Failed to load events');
                }
                return res.json();
            })
            .then((data) => {
                setEvents(data);
                setLoading(false);
            })
            .catch(() => {
                setError(true);
                setLoading(false);
            });
    }, []);

    // BS: compute status live from date/time so events move to "past" the moment they finish,
    // without waiting for an admin edit to refresh the stored status field
    const sortedEvents = events
        .filter((event) => getEventStatus(event.date, event.time) === filter)
        .sort((a, b) => new Date(a.date) - new Date(b.date));
    const visibleEvents = limit ? sortedEvents.slice(0, limit) : sortedEvents;
    const emptyMessage = filter === 'past'
        ? 'No past events to show yet — check back after our next race!'
        : 'No upcoming events right now — check back soon!';

    return (
        <div>
            {loading && <p className={classes.message}>Loading events...</p>}
            {!loading && (error || visibleEvents.length === 0) && (
                <p className={classes.message}>{emptyMessage}</p>
            )}
            {!loading && !error && visibleEvents.length > 0 && (
                <div className={classes.cards}>
                    {visibleEvents.map((event) => (
                        <CardEvent key={event.id} event={event} onSelect={setSelectedEvent} />
                    ))}
                </div>
            )}
            <EventModal event={selectedEvent} onClose={() => setSelectedEvent(null)} />
        </div>
    );
}
